/* HERO CALC END */

$(document).ready(function(){
  const isCart = window.location.href.includes('cart')
  setProdSize()
  updateCartOrder()
  if(!isCart) {
      hideSpecificElements()
      deleteOldestRecordIfNeeded('kl-onsite-modules', 'kl-event-cache', 10) 
    }
})

$(window).load(function(){
  setProdSize()
})

$(window).resize(function(){
  setProdSize()
})

function setProdSize() {
  $('.prod-size').each(function(){
    $(this).height($(this).width())
  })
}

function updateCartOrder() {
  const addToOrderBtn = document.getElementById('add_to_orderno');
  if(!addToOrderBtn) return;
  
  addToOrder.addEventListener('click', function () {
    const orderno = document.getElementById('orderno').value;
    const updateData = { updates: { 12733761028173: orderno && !addToOrderBtn.classList.contains('existing') ? 1 : 0 } };
    fetch(ShopRoutes("cart_update_url", ".js"), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updateData)
    })
    .then(response => response.json())
    .then(() => {
        if (orderno && !addToOrderBtn.classList.contains('existing')) {
            document.cookie = `order_number=${orderno}; path=/;`;
        }
        location.reload();
    })
    .catch(error => console.error('Error updating cart:', error));
});
}

function deleteOldestRecordIfNeeded(dbName, storeName, maxRecords) {
    const request = indexedDB.open(dbName);

    request.onsuccess = function (event) {
        const db = event.target.result;
        const transaction = db.transaction(storeName, 'readwrite');
        const store = transaction.objectStore(storeName);
        const countRequest = store.count();

        countRequest.onsuccess = function () {
            if (countRequest.result > maxRecords) {
                const cursorRequest = store.openCursor(null, 'next');

                cursorRequest.onsuccess = function (event) {
                    const cursor = event.target.result;
                    if (cursor) {
                        store.delete(cursor.key);
                        console.log(`Deleted record with key ${cursor.key}`);
                    }
                };
            } else {
                console.log(`Database size within limit: ${countRequest.result} records.`);
            }
        };

        countRequest.onerror = function () {
            console.error("Failed to count records:", countRequest.error);
        };
    };

    request.onerror = function (event) {
        console.error(`Failed to open database '${dbName}':`, event.target.error);
    };
}

function hideSpecificElements() {
    const sitesToHide = ['mygreetings'];
    const url = window.location.href;
    const shouldHide = sitesToHide.some(value => url.endsWith(value))
    const logoCarousel = document.getElementById('shopify-section-logo-carousel');
    if(logoCarousel && shouldHide) {
        logoCarousel.style.display = 'none';
    }

    const ctaElement = document.getElementById('shopify-section-CTA-myselfie');
    if(ctaElement) {
      ctaElement.style.display = 'none';
    }
}

window.addEventListener('load', function() {
  (function() {    
    var inputList = document.querySelectorAll('input[name="return_to"]');
    
    if (inputList.length > 0) {

      if (window.location) {
        if (window.location.search) {
          if (window.location.search.length > 0) {
            inputList.forEach(function(item) {

              var oldText = item.value;

              item.value = oldText + window.location.search; 
            });
          }
        }
      }
    }
  })();
});